// extracted by mini-css-extract-plugin
export default {"main":"Settings_main__zon-q"};